import React, { useState } from "react";
import { Box, Button } from "@cloudscape-design/components";
import FeedbackModal from "./FeedbackModal";
import deploymentConfig from "../config/deployment";
import "../styles/Footer.css";

const Footer = () => {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);

  return (
    <>
      <Box className="footer">
        <div className="footer-content">
          <div className="footer-meta">
            {deploymentConfig.lastDeploymentDate} &middot; {deploymentConfig.llmModel}
          </div>
          <div className="footer-center">
            &copy; {new Date().getFullYear()}, Amazon Web Services, Inc. or its affiliates. All rights reserved.
          </div>
          <div className="footer-actions">
            <Button
              variant="link"
              onClick={() => setShowFeedbackModal(true)}
              className="feedback-button"
            >
              Provide Feedback
            </Button>
          </div>
        </div>
      </Box>

      {showFeedbackModal && (
        <FeedbackModal
          visible={showFeedbackModal}
          onDismiss={() => setShowFeedbackModal(false)}
        />
      )}
    </>
  );
};

export default Footer;
